module.exports = __webpack_public_path__ + "static/img/53.d5a28b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Microsoft365Security/53.png
// module id = Mxbl
// module chunks = 1